function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LayoutFormat from "../Layout/LayoutFormat";
import LayoutGrid from "../Layout/LayoutGrid";
import ModuleBase from "./ModuleBase";
import ModuleHeader from "./ModuleHeader";
import ModuleBody from "./ModuleBody";
import ModuleFooter from "./ModuleFooter";
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    position: "relative",
    zIndex: 2,
    "& + *": {
      zIndex: 1
    },
    display: "flex",
    flexDirection: "column"
  },
  header: {
    position: "absolute",
    zIndex: 2,
    top: 0,
    right: 0,
    bottom: "auto",
    left: 0,
    display: "flex",
    zIndex: 2,
    alignItems: "center",
    justifyContent: "flex-start",
    height: theme.spacing(7),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: "inherit",
    "& + *": {
      zIndex: 1,
      marginTop: theme.spacing(7)
    }
  },
  body: {
    flexGrow: 1,
    marginTop: theme.spacing(7),
    position: "relative",
    padding: props => {
      return theme.spacing(props.padding);
    }
  },
  footer: {
    borderTop: "1px solid",
    borderColor: theme.palette.divider,
    padding: props => {
      return theme.spacing(props.padding);
    }
  }
}));

const EditModule = (_ref) => {
  let id = _ref.id,
      status = _ref.status,
      format = _ref.format,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 2 : _ref$padding,
      _ref$buttons = _ref.buttons,
      buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
      onSave = _ref.onSave,
      toolbar = _ref.toolbar,
      children = _ref.children,
      _action = _ref._action,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "status", "format", "padding", "buttons", "onSave", "toolbar", "children", "_action"]);

  const classes = useStyles({
    padding
  });

  if (!buttons.length) {
    buttons.push({
      label: "Save",
      onClick: onSave
    });
  }

  if (!buttons.length && !children) {
    return false;
  }

  toolbar = toolbar.map(item => {
    if (item.type === "edit") {
      return false;
    }

    return item;
  });
  return React.createElement(ModuleBase, {
    className: classes.root,
    id: id,
    expanded: true,
    elevation: 4,
    status: status
  }, React.createElement(LayoutFormat, props, React.createElement(ModuleHeader, _extends({}, props, {
    className: classes.header,
    status: status,
    toolbar: toolbar
  })), children), React.createElement(ModuleFooter, _extends({}, props, {
    className: classes.footer,
    buttons: buttons
  })));
  return React.createElement(ModuleBase, {
    className: classes.root,
    id: id,
    expanded: true,
    elevation: 4,
    status: status
  }, React.createElement(LayoutFormat, props, React.createElement(ModuleHeader, _extends({}, props, {
    className: classes.header,
    status: status,
    toolbar: toolbar
  })), React.createElement(ModuleBody, {
    className: classes.body,
    padding: padding
  }, children)), React.createElement(ModuleFooter, _extends({}, props, {
    className: classes.footer,
    buttons: buttons
  })));
};

EditModule.propTypes = process.env.NODE_ENV !== "production" ? {
  onSave: PropTypes.func,
  menu: PropTypes.array,
  title: PropTypes.string,
  children: PropTypes.node
} : {};
export default EditModule;